import {getCurrentInstance, ref, watch, nextTick,} from 'vue'

export function useTouch ({elemSelector,loadingElemId,goPrev,goNext,hasPrev,hasNext,threshold,onlyTouch,onlyMobile,}) {
    let {proxy,} = getCurrentInstance()
    threshold = threshold || 'vw'
    onlyTouch = onlyTouch || false
    onlyMobile = onlyMobile || (() => false)
    hasPrev = hasPrev || (() => true)
    hasNext = hasNext || (() => true)

    let loadingOpacity = ref(0)
    let hammer = null
    let _oldScrollPos = 0

    const initializeHammer = async function () {
        if(onlyMobile(proxy) || (onlyTouch && !globalThis.isTouchDevice)) {
            if (hammer) {
                hammer.destroy()
                hammer = null
            }

            return
        }

        const {default: Hammer,} = await import('hammerjs')
        delete Hammer.defaults.cssProps.userSelect
        let times = 0
        let elem = null

        const interval = setInterval(() => {
            times += 1
            if (elem || times === 20) {
                clearInterval(interval)
                if(elem) {
                    let loadingElem = document.getElementById(loadingElemId)
                    hammer = new Hammer(elem)

                    // force Touch Animation reset
                    let resetTransform = ()=>{
                        loadingOpacity.value = 0
                        elem.style.transform = null
                        elem.style.opacity = null
                        setTimeout(()=>{
                            elem.style.transition = null
                        },500)
                    }
                    elem.addEventListener('touchend',resetTransform)
                    elem.addEventListener('touchcancel',resetTransform)

                    if(threshold === 'vw') {
                        threshold = window.innerWidth / 2 / 1.1
                    }

                    //enable all directions
                    hammer.get('pan').set({
                        direction: Hammer.DIRECTION_HORIZONTAL,
                    })

                    let hasPrevVal = true
                    let hasNextVal = true

                    // listen to events...
                    hammer.on("panright panleft panend panstart", (ev) => {
                        let scrollPos = window.pageYOffset || ev.target.scrollTop || 0
                        let isScrolling = scrollPos !== _oldScrollPos
                        _oldScrollPos = scrollPos

                        let isSelection = false
                        let selObj = document.getSelection()
                        if(selObj) {
                            isSelection = selObj.type === 'Range'
                        }

                        if(isScrolling || isSelection) {
                            resetTransform()

                            return
                        }
                        if(ev.type === 'panstart') {
                            hasPrevVal = hasPrev(proxy)
                            hasNextVal = hasNext(proxy)
                        }
                        if((ev.type === 'panright' || ev.type === 'panleft') && Math.abs(ev.velocityX) > Math.abs(ev.velocityY)) {
                            let delta = ev.deltaX

                            if((!hasPrevVal && ev.deltaX >= 0) || (!hasNextVal && ev.deltaX <= 0)) {
                                return
                            }

                            if(elem) {
                                if(Math.abs(ev.deltaX) > threshold * 1.1) {
                                    delta = threshold * 1.1 * ev.deltaX / Math.abs(ev.deltaX)
                                }

                                elem.style.transform = `translateX(${delta}px)`
                                let base = threshold / 2
                                if(loadingElem && Math.abs(delta) >= base) {
                                    let opacity = (Math.abs(delta) - base) / (threshold * 1.1 - base)
                                    elem.style.opacity = 1 - opacity
                                    loadingOpacity.value = opacity
                                }
                            }
                        }
                        if(ev.type === 'panend') {
                            if(Math.abs(ev.deltaX) > threshold) {
                                try {
                                    ev.deltaX >= 0 ?
                                        goPrev.call(proxy) :
                                        goNext.call(proxy)
                                } catch { /* empty */ }
                            } else {
                                if(elem) {
                                    elem.style.transition = 'all 0.4s cubic-bezier(1,1.56,.37,.75)'
                                }
                            }
                            if(elem) {
                                nextTick(()=>{
                                    resetTransform()
                                })
                            }
                        }
                    })
                }
            }
            elem = document.querySelector(elemSelector)
        }, 100)
    }

    watch(()=> proxy.$vuetify?.display?.smAndDown,
        (newValue, oldValue) => {
            if (newValue !== oldValue) {
                initializeHammer()
            }
        }, {immediate: !import.meta.env.SSR,})

    return {
        loadingOpacity,
    }
}
